import { MerchantUser } from 'api/merchantUsers'
import { rolesApi } from 'api/roles'
import HeaderCell from 'components/HeaderCell'
import useFlag from 'hooks/useFlag'
import useIsAdmin from 'hooks/useIsAdmin'
import { buildTranslate } from 'locales'
import { useState } from 'react'
import DeleteModal from './DeleteModal'
import Row from './Row'

const t = buildTranslate('merchant_users.merchant_users_list.table')

type Props = {
  merchantUsers: MerchantUser[]
}

const Table = ({ merchantUsers }: Props) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [selectedMerchantUser, setSelectedMerchantUser] =
    useState<MerchantUser>()
  const rbacEnabled = useFlag('role-based-access-control', false)
  const isAdmin = useIsAdmin()
  const { data: rolesData, isSuccess: rolesLoaded } = rolesApi.useGetRolesQuery(
    undefined,
    { skip: !rbacEnabled }
  )
  const allRoles = rolesData?.roles ?? []

  return (
    <>
      <table className="full-width">
        <thead>
          <tr>
            <HeaderCell key="name" className={'w-25'}>
              {t('name')}
            </HeaderCell>
            <HeaderCell key="role" className={'w-50'}>
              {t('role')}
            </HeaderCell>
            <HeaderCell key="status">{t('status')}</HeaderCell>
            <HeaderCell key="edit"></HeaderCell>
            <HeaderCell key="remove"></HeaderCell>
          </tr>
        </thead>
        <tbody data-testid="table-body">
          {merchantUsers.map(merchantUser => (
            <Row
              key={merchantUser.id}
              merchantUser={merchantUser}
              allRoles={allRoles}
              rolesLoaded={rolesLoaded}
              rbacEnabled={rbacEnabled}
              canManage={isAdmin}
              onRemove={() => {
                setSelectedMerchantUser(merchantUser)
                setDeleteModalVisible(true)
              }}
            />
          ))}
        </tbody>
      </table>
      <DeleteModal
        visible={deleteModalVisible}
        setIsVisible={setDeleteModalVisible}
        merchantUser={selectedMerchantUser}
      />
    </>
  )
}

export default Table
